// FAQList.jsx
import { useNavigate } from 'react-router-dom';

const FAQList = () => {
  const navigate = useNavigate();
  const faqs = Array(10).fill("Lorem Ipsum is simply dummy text?");
  return (
    <div className="min-h-screen bg-white p-4">
      <div className="flex justify-between items-center mb-4">
        <button>&larr;</button>
        <h2 className="font-bold">Help Chat</h2>
        <div></div>
      </div>

      <div className="flex rounded-full border border-red-600 overflow-hidden mb-4">
        <button className="px-6 py-2 text-sm">Ask</button>
        <button className="bg-primary text-white px-6 py-2 text-sm">FAQs</button>
      </div>

      <div className="flex flex-wrap gap-2 mb-4">
        {['General', 'Receipt', 'Payment', 'Orders', 'Account'].map(tag => (
          <button key={tag} className="bg-gray-100 text-xs px-3 py-1 rounded-full">{tag}</button>
        ))}
      </div>

      <input type="text" placeholder="Search" className="w-full border px-4 py-2 mb-4 rounded-lg text-sm" />

      <div className="space-y-3">
        {faqs.map((q, idx) => (
          <div
            key={idx}
            className="flex justify-between items-center p-3 border rounded-lg cursor-pointer"
            onClick={() => navigate(`/faq/${idx}`)}
          >
            <p className="text-sm">{q}</p>
            <span className="bg-primary text-primary rounded-full px-2 py-1 text-xs">?</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQList;
